module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-precomposed.6b9b7790174aa1b4753734c09fc21dfd.png";